
















































































































































































































































import { Component, Prop } from 'vue-property-decorator'
import AbpBase from '@/lib/abpbase'
import PromotionActivityApi from '@/api/marketing/promotionActivity/index'
import OutfitProductExpand from './outfit-product-expand.vue'
import GoodSelect from '@/components/goods-select/index.vue'
import PromotionProductManager from './product/index.vue'
@Component({
  components: {
    OutfitProductExpand,
    GoodSelect,
    PromotionProductManager
  },
})
export default class PromotionActivityDetail extends AbpBase {
  activityId: string = ''
  val: string[] = ['1', '2', '3']
  data: any = {
    productFilterConfig: {
      scope: '',
    },
    platform: '商家',
  }
  productScopeDisplayName = {
    condition: '指定条件',
    product: '指定商品',
    all: '全部商品',
  }
  getPromotionType() {
    return this.data.type
  }
  columns10 = [
    {
      type: 'expand',
      width: 50,
      render: (h, params) => {
        return h(OutfitProductExpand, {
          props: {
            row: params.row,
          },
        })
      },
    },
    {
      title: '图片',
      slot: 'pictureUrl',
      width: 320,
      align: 'center',
    },
    {
      title: '套装价格',
      key: 'outfitPrice',
      width: 320,
      align: 'center',
    },
  ]
  columns1 = [
    {
      title: '商品名称',
      key: 'productName',
      width: 320,
      align: 'center',
    },
    {
      title: '品牌',
      key: 'brandName',
      width: 120,
      align: 'center',
    },
    {
      title: '市场价',
      key: 'marketPrice',
      width: 120,
      align: 'center',
    },
    {
      renderHeader: (h, params) => {
        let promotionType = this.getPromotionType()
        let title
        if (promotionType === 'preSales') {
          title = '预售价'
        } else {
          title = '零售价'
        }
        return h('span', {}, [title])
      },
      key: 'price',
      width: 120,
      align: 'center',
    },
    {
      renderHeader: (h, params) => {
        let promotionType = this.getPromotionType()
        let title
        switch (promotionType) {
          case 'preSales':
            title = '预售定金'
            break
          case 'group':
            title = '拼团价'
            break
          case 'secKill':
            title = '秒杀价'
            break
          case 'limitRewardPointExchange':
            title = '兑换价'
            break
          default:
            title = '活动价'
            break
        }
        return h('span', {}, [title])
      },
      key: 'promotionPrice',
      width: 120,
      align: 'center',
    },
    {
      title: '货号',
      key: 'productCode',
      width: 120,
      align: 'center',
    },
  ]
  mounted() {
    if (this.$route.query.id !== undefined) {
      this.activityId = this.$route.query.id.toString()
      this.loadActivityDetail()
    }
  }

  loadActivityDetail() {
    PromotionActivityApi.getPromotionActivity(this.activityId).then((res) => {
      this.data = res.data
    })
  }
}
